import React from 'react';
import CustomSection from '../../custom-general/custom-section';
import classNames from './style.module.scss';

import { getOptimizedImageURL, preventImageCaching } from '../../../../utils/utilities';
import { PDFImageProps } from '../../../../utils/models';

interface GeneralDrawingProps {
	generalDrawing: PDFImageProps[];
	identifier?: string;
}

const GeneralDrawing: React.FC<GeneralDrawingProps> = ({ generalDrawing, identifier }) => {
	return (
		<>
			{generalDrawing.map((drawing) => (
				<CustomSection identifier={identifier} key={drawing.refNo} sectionTitle="General Drawing">
					<div className={classNames.anomalyLocation}>
						<img
							src={preventImageCaching(getOptimizedImageURL(drawing.src))}
							alt={drawing.caption}
						/>
					</div>
				</CustomSection>
			))}
		</>
	);
};

export default GeneralDrawing;
